/*
 * module.js - The description of the module.
 */

Fundu.Pages.Allocator = (function($) {

    // Properties
    ///////////////////////////

    var _allocatorInvestments = false;
    var _ownInvestments = false;
    var _allInvestments = false;
    var _investmentDataButtons = false;

    var _allocatorSettings = false;

    // Private Methods
    ///////////////////////////

    var selectElements = function () {
        _allocatorInvestments = $("#allocator-investments");
        _ownInvestments = $("#own-investments");
        _allInvestments = $("#all-investments");
        _investmentDataButtons = $('#investmentDataButtons .btn-primary');

        _allocatorSettings = $('#allocator-settings');
    };

    var initializeInvestmentDataTableButtons = function () {
        _investmentDataButtons.on('click', function () {
            switch ($(this).find('input').attr('id')) {
                case 'allocator-option':
                    showAllocatorInvestments();
                    break;
                case 'manual-option':
                    showOwnInvestments();
                    break;
                case 'all-option':
                    showAllInvestments();
                    break;
            }
        });
    };

    var showAllocatorInvestments = function () {
        _allocatorInvestments.css("display", "inline");
        _ownInvestments.css("display", "none");
        _allInvestments.css("display", "none");
    };

    var showOwnInvestments = function () {
        _allocatorInvestments.css("display", "none");
        _ownInvestments.css("display", "inline");
        _allInvestments.css("display", "none");
    };

    var showAllInvestments = function () {
        _allocatorInvestments.css("display", "none");
        _ownInvestments.css("display", "none");
        _allInvestments.css("display", "inline");
    };

    // Init
    ///////////////////////////
    var initialize = function() {
        selectElements();

        if (_allocatorSettings.length > 0) {
            Fundu.Components.AllocatorSettings.init();
        }

        initializeInvestmentDataTableButtons();
        showAllocatorInvestments();

        return $.Deferred().resolve(true);
    };

    var finalize = function() {

    };

    // Reveal public methods
    return {
        init: initialize,
        finalize: finalize
    }

})(jQuery);
